function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.002 73.945a3.5 3.5 0 0 0 2.05 3.098l31 14.072A3.5 3.5 0 0 0 38 87.925l-.05-75.857a3.5 3.5 0 0 0-5.58-2.812L4.474 29.869a3.5 3.5 0 0 0-1.41 2.555L.01 73.596a3.5 3.5 0 0 0-.008.35zm7.17-2.267l2.754-37.135l21.027-15.54l.043 63.491zM47.5 100h5V90h-5zm0-15h5V75h-5zm0-15h5V60h-5zm0-15h5V45h-5zm0-15h5V30h-5zm0-15h5V15h-5zm0-15h5V0h-5zM62 87.926a3.5 3.5 0 0 0 4.947 3.19l31-14.073a3.5 3.5 0 0 0 2.051-3.098a3.5 3.5 0 0 0-.008-.35l-3.054-41.171a3.5 3.5 0 0 0-1.41-2.555L67.63 9.256a3.5 3.5 0 0 0-5.58 2.812z",
  className: "icon-primary"
});

function SvgMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--gis",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.a2302507.svg";
export { ForwardRef as ReactComponent };